/* eslint-disable react/jsx-no-undef */
import React,{Component} from 'react';
import './css/FooterRight.css'
class FooterCopyRight extends Component{
  render(){
    return(
      <div className="FooterCopyRight">
          <p>
          2019 imooc.com  京ICP备 12003892号-11 北京奥鹏文化传媒有限公司
          </p>
      </div>
    )
  }
}

export default FooterCopyRight;